<template>
    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13.9158 1.28712C14.3731 0.79133 15.1367 0.768629 15.6214 1.23642C16.0689 1.66822 16.1222 2.36701 15.768 2.86192L15.671 2.98112L6.39223 13.2076L0.239078 6.64919C-0.159044 6.10257 -0.048575 5.32932 0.485818 4.92209C0.979103 4.54618 1.66117 4.61355 2.07632 5.05607L2.17428 5.17447L6.39223 9.54769L13.9158 1.28712Z"
        />
    </svg>
</template>
